import { useEffect, useState } from 'react';

const CAMPAIGN_END_MONTH = 10; // novembro (0-indexed)
const CAMPAIGN_END_DAY = 30;

function campaignEnd() {
    const now = new Date();
    return new Date(now.getFullYear(), CAMPAIGN_END_MONTH, CAMPAIGN_END_DAY, 23, 59, 59);
}

/**
 * Dias restantes até 30/11 (fim da campanha). Calculado no cliente pra não
 * depender do relógio do servidor, e recalculado 1x/hora — não precisa de
 * mais resolução que isso pra uma contagem em dias.
 */
export default function useCountdown() {
    const [daysLeft, setDaysLeft] = useState(() => computeDaysLeft());

    useEffect(() => {
        const interval = setInterval(() => setDaysLeft(computeDaysLeft()), 60 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    return daysLeft;
}

function computeDaysLeft() {
    const diffMs = campaignEnd().getTime() - Date.now();
    return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}
